import React from 'react'

const useProgressiveImg = (lowQualitySrc: string, highQualitySrc: string) => {
  const [src, setSrc] = React.useState(lowQualitySrc)

  React.useEffect(() => {
    const img = new Image()

    img.src = highQualitySrc

    img.onload = () => {
      setSrc(highQualitySrc)
    }
  }, [lowQualitySrc, highQualitySrc])

  return {
    srcLoaded: src,
    // in small images, the thumbnail is the same as the hq source
    blur: lowQualitySrc !== highQualitySrc ? src === lowQualitySrc : false,
  }
}
export default useProgressiveImg
